import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import { httpGetViewOnlySubgeos } from '../http/get-view-only-subgeos.http'

interface UseGetViewOnlySubgeosParams {
	geoId: string
}

export const useGetViewOnlySubgeos = (
	params: UseGetViewOnlySubgeosParams,
	options?: { enabled?: boolean }
) => {
	const query = useQuery({
		queryKey: [QUERY_KEYS.GET_VIEW_ONLY_SUBGEOS, params.geoId],
		queryFn: () => httpGetViewOnlySubgeos(params),
		enabled: options?.enabled && !!params.geoId
	})

	return {
		...query,
		viewOnlySubgeos: query.data ?? []
	}
}
